import { styled } from '@mui/material/styles';
import { Menu } from '@mui/material';

export const classes = {
  paper: `.MuiPaper-root`,
  list: `.MuiList-root`,
};

export const StyledMaterialMenu = styled(Menu)`
  & ${classes.paper} {
    box-shadow: none;
    border-radius: 0;
  }

  & ${classes.list} {
    padding: 0;
  }
`;
